import React, { Component, Fragment } from "react";
import Functions from "../../../src/functions";

class Footer extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createData.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createData() {
    let output = [];
    let UserType = Functions["custom"]["getUserType"]();
    if (
      UserType === "POSTB" ||
      UserType === "POSTB_SPLIT" ||
      UserType === "POSTR"
    ) {
      this.state.data.map((itm, idx) => {
        output.push(
          <Fragment key={idx}>
            {itm.showNextUpdate.component}
            {itm.showTermVat.component}
          </Fragment>
        );
      });
    }
    return <div>{output}</div>;
  }

  render() {
    if (this.state.loaded) {
      return this.createData();
    } else {
      return "";
    }
  }
}

export default Footer;
